import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, ListGroup, Row, Table } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrintJobs } from "../../redux/slices/IdiqApiSlice";
import { Download } from "react-feather";
import { PaginationControl } from 'react-bootstrap-pagination-control';

const PrintJobs = () => {
  const dispatch = useDispatch();
  const [printJobs, setPrintJobs] = useState([])
  const [page, setPage] = useState(1)
  const [totalJobs, setTotalJobs] = useState(0)
  const perPage = 10;


  useEffect(() => {
    getPrintJobs(page)
  }, [])

  const getPrintJobs = async (page) => {
    try {
      const jobs = await dispatch(fetchPrintJobs(page)).unwrap();
      setTotalJobs(jobs.data.total)
      setPrintJobs(jobs.data.records)
      setPage(page)
    } catch (error) {
      //console.log(error.message)
    }
  }

  


  return (
    <React.Fragment>
      <Helmet title='Print Jobs' />
      <Container fluid className='p-0 container-fluid-1335'>
        <Card color="white">
          <Card.Body>
            <h3 className="mb-3">Print Jobs</h3>
            <Table bordered striped bgcolor="white">
              <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Job Date</th>
                  <th>Disputes Plan</th>
                  <th>Printer</th>
                  <th>Round</th>
                  <th>Destination</th>
                  <th>Letter</th>
                </tr>
              </thead>
              <tbody>
                {
                  printJobs.map(job =>
                    <tr>
                      <td>{job.job_name}</td>
                      <td>{job.job_date}</td>
                      <td>{job.dispute_type === "PREMIUM" ? "ENHANCED" : job.dispute_type}</td>
                      <td>{job.printer}</td>
                      <td>{job.round}</td>
                      <td>{job.destination}</td>
                      <td><a href={job.file_url} target="__blank" download={true}><Download /></a></td>
                    </tr>)
                }
              </tbody>
            </Table>
          </Card.Body>
          <Card.Footer>

            <PaginationControl
              page={page}
              between={2}
              next={true}
              last={true}
              ellipsis={2}
              total={totalJobs}
              limit={perPage}
              changePage={(currentPage) => {
                getPrintJobs(currentPage)
              }}
            />
          </Card.Footer>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default PrintJobs;